"use strict"; // Copyright (C) 2021 Toitware ApS. All rights reserved.
// Use of this source code is governed by an MIT-style license that can be
// found in the LICENSE file.

var _createForOfIteratorHelper = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EspLoader = exports.ESP_ROM_BAUD = exports.ChipFamily = void 0;

var errors_1 = require("./errors");

var reader_1 = require("./reader");

var stubs_1 = require("./stubs");

var util_1 = require("./util");

var ChipFamily;

(function (ChipFamily) {
  ChipFamily["ESP32"] = "esp32";
  ChipFamily["ESP8266"] = "esp8266";
  ChipFamily["ESP32S2"] = "esp32S2";
})(ChipFamily = exports.ChipFamily || (exports.ChipFamily = {}));

var FLASH_WRITE_SIZE = 0x400;
var STUB_FLASH_WRITE_SIZE = 0x4000; // Flash sector size, minimum unit of erase.

var FLASH_SECTOR_SIZE = 0x1000;
exports.ESP_ROM_BAUD = 115200;
var SYNC_PACKET = (0, util_1.toByteArray)("\x07\x07\x12 UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU");
var CHIP_DETECT_MAGIC_REG_ADDR = 0x40001000;
var ESP32_DETECT_MAGIC_VALUE = 0x00f01d83;
var ESP8266_DETECT_MAGIC_VALUE = 0xfff0c101;
var ESP32S2_DETECT_MAGIC_VALUE = 0x000007c6;
var UART_CLKDIV_REG = 0x3ff40014;
var UART_CLKDIV_MASK = 0xfffff; // Commands supported by ESP8266 ROM bootloader

var ESP_FLASH_BEGIN = 0x02;
var ESP_FLASH_DATA = 0x03;
var ESP_FLASH_END = 0x04;
var ESP_MEM_BEGIN = 0x05;
var ESP_MEM_END = 0x06;
var ESP_MEM_DATA = 0x07;
var ESP_SYNC = 0x08;
var ESP_READ_REG = 0x0a;
var ESP_ERASE_FLASH = 0xd0;
var ESP_SPI_SET_PARAMS = 0x0b;
var ESP_SPI_ATTACH = 0x0d;
var ESP_CHANGE_BAUDRATE = 0x0f;
var ESP_CHECKSUM_MAGIC = 0xef;
var ESP_RAM_BLOCK = 0x1800; // Timeouts

var DEFAULT_TIMEOUT = 3000; // timeout for most flash operations

var CHIP_ERASE_TIMEOUT = 120000; // timeout for full chip erase

var MAX_TIMEOUT = CHIP_ERASE_TIMEOUT * 2; // longest any command can run

var SYNC_TIMEOUT = 100; // timeout for syncing with bootloader

var ERASE_REGION_TIMEOUT_PER_MB = 30000; // timeout (per megabyte) for erasing a region

var MEM_END_ROM_TIMEOUT = 50;

var EspLoader = /*#__PURE__*/function () {
  function EspLoader(serialPort, options) {
    _classCallCheck(this, EspLoader);

    this.isStub = false;
    this.baudRate = exports.ESP_ROM_BAUD;
    this._sendCommandBuffer = new util_1.Uint8BufferSlipEncode();
    this._flashBlockBuffer = new util_1.Uint8Buffer();
    this._memBlockBuffer = new util_1.Uint8Buffer();
    this.options = Object.assign({
      flashSize: 4 * 1024 * 1024,
      logger: console,
      debug: false
    }, options || {});
    this.reader = new reader_1.Reader(serialPort);
    this.serialPort = serialPort;
  }

  _createClass(EspLoader, [{
    key: "writeToStream",
    value: function () {
      var _writeToStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(msg) {
        var writer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                writer = this.serialPort.writable.getWriter();
                _context.prev = 1;
                _context.next = 4;
                return writer.write(msg);

              case 4:
                _context.prev = 4;
                writer.releaseLock();
                return _context.finish(4);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 4, 7]]);
      }));

      function writeToStream(_x) {
        return _writeToStream.apply(this, arguments);
      }

      return writeToStream;
    }()
    /**
     * Put into ROM bootload mode & attempt to synchronize with the
     * ESP ROM bootloader, we will retry a few times
     */

  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var retries,
            connected,
            i,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                retries = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 7;
                this.reader.start();
                connected = false;
                i = 0;

              case 4:
                if (!(i < retries)) {
                  _context2.next = 14;
                  break;
                }

                if (i > 0) {
                  this.options.logger.log("retrying...");
                }

                _context2.next = 8;
                return this.try_connect();

              case 8:
                if (!_context2.sent) {
                  _context2.next = 11;
                  break;
                }

                connected = true;
                return _context2.abrupt("break", 14);

              case 11:
                i++;
                _context2.next = 4;
                break;

              case 14:
                if (connected) {
                  _context2.next = 16;
                  break;
                }

                throw errors_1.ConnectError;

              case 16:
                _context2.next = 18;
                return this.reader.waitSilent(1, 200);

              case 18:
                _context2.next = 20;
                return this.chipFamily();

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "try_connect",
    value: function () {
      var _try_connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var wasSilent, i;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.serialPort.setSignals({
                  dataTerminalReady: false,
                  requestToSend: true
                });

              case 2:
                _context3.next = 4;
                return (0, util_1.sleep)(100);

              case 4:
                _context3.next = 6;
                return this.serialPort.setSignals({
                  dataTerminalReady: true,
                  requestToSend: false
                });

              case 6:
                _context3.next = 8;
                return (0, util_1.sleep)(50);

              case 8:
                _context3.next = 10;
                return this.serialPort.setSignals({
                  dataTerminalReady: false,
                  requestToSend: false
                });

              case 10:
                _context3.next = 12;
                return this.reader.waitSilent(20, 1000);

              case 12:
                wasSilent = _context3.sent;

                if (wasSilent) {
                  _context3.next = 16;
                  break;
                }

                this.options.logger.log("failed to enter bootloader");
                return _context3.abrupt("return", false);

              case 16:
                this.options.logger.log("trying to sync with bootloader..."); // Try sync.

                this.options.logger.debug("sync started");
                i = 0;

              case 19:
                if (!(i < 7)) {
                  _context3.next = 36;
                  break;
                }

                _context3.prev = 20;
                _context3.next = 23;
                return this.sync();

              case 23:
                if (!_context3.sent) {
                  _context3.next = 26;
                  break;
                }

                this.options.logger.log("synced with bootloader");
                return _context3.abrupt("return", true);

              case 26:
                _context3.next = 31;
                break;

              case 28:
                _context3.prev = 28;
                _context3.t0 = _context3["catch"](20);
                this.options.logger.debug("sync error", _context3.t0);

              case 31:
                _context3.next = 33;
                return (0, util_1.sleep)(50);

              case 33:
                i++;
                _context3.next = 19;
                break;

              case 36:
                this.options.logger.debug("sync stopped");
                this.options.logger.log("failed to sync with bootloader");
                return _context3.abrupt("return", false);

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[20, 28]]);
      }));

      function try_connect() {
        return _try_connect.apply(this, arguments);
      }

      return try_connect;
    }()
    /**
     * shutdown the read loop.
     */

  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var err;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.reader.stop();

              case 2:
                err = _context4.sent;

                if (!(err !== undefined)) {
                  _context4.next = 5;
                  break;
                }

                throw err;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "crystalFrequency",
    value: function () {
      var _crystalFrequency = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var uart_div, ets_xtal, norm_xtal;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.readRegister(UART_CLKDIV_REG);

              case 2:
                _context5.t0 = _context5.sent;
                _context5.t1 = UART_CLKDIV_MASK;
                uart_div = _context5.t0 & _context5.t1;
                ets_xtal = this.baudRate * uart_div / 1000000 / 1;

                if (ets_xtal > 33) {
                  norm_xtal = 40;
                } else {
                  norm_xtal = 26;
                }

                if (Math.abs(norm_xtal - ets_xtal) > 1) {
                  this.logger.debug("WARNING: Unsupported crystal in use");
                }

                return _context5.abrupt("return", norm_xtal);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function crystalFrequency() {
        return _crystalFrequency.apply(this, arguments);
      }

      return crystalFrequency;
    }()
    /**
     * @name macAddr
     * Read MAC from OTP ROM
     */

  }, {
    key: "macAddr",
    value: function () {
      var _macAddr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var efuses, chipFamily, macAddr, mac0, mac1, mac2, mac3, oui, res, i;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.efuses();

              case 2:
                efuses = _context6.sent;
                _context6.next = 5;
                return this.chipFamily();

              case 5:
                chipFamily = _context6.sent;
                macAddr = new Uint8Array(6).fill(0);
                mac0 = efuses[0];
                mac1 = efuses[1];
                mac2 = efuses[2];
                mac3 = efuses[3];

                if (!(chipFamily === ChipFamily.ESP8266)) {
                  _context6.next = 33;
                  break;
                }

                if (!(mac3 != 0)) {
                  _context6.next = 16;
                  break;
                }

                oui = [mac3 >> 16 & 0xff, mac3 >> 8 & 0xff, mac3 & 0xff];
                _context6.next = 25;
                break;

              case 16:
                if (!((mac1 >> 16 & 0xff) == 0)) {
                  _context6.next = 20;
                  break;
                }

                oui = [0x18, 0xfe, 0x34];
                _context6.next = 25;
                break;

              case 20:
                if (!((mac1 >> 16 & 0xff) == 1)) {
                  _context6.next = 24;
                  break;
                }

                oui = [0xac, 0xd0, 0x74];
                _context6.next = 25;
                break;

              case 24:
                throw "Couldnt determine OUI";

              case 25:
                macAddr[0] = oui[0];
                macAddr[1] = oui[1];
                macAddr[2] = oui[2];
                macAddr[3] = mac1 >> 8 & 0xff;
                macAddr[4] = mac1 & 0xff;
                macAddr[5] = mac0 >> 24 & 0xff;
                _context6.next = 43;
                break;

              case 33:
                if (!(chipFamily === ChipFamily.ESP32 || chipFamily === ChipFamily.ESP32S2)) {
                  _context6.next = 42;
                  break;
                }

                macAddr[0] = mac2 >> 8 & 0xff;
                macAddr[1] = mac2 & 0xff;
                macAddr[2] = mac1 >> 24 & 0xff;
                macAddr[3] = mac1 >> 16 & 0xff;
                macAddr[4] = mac1 >> 8 & 0xff;
                macAddr[5] = mac1 & 0xff;
                _context6.next = 43;
                break;

              case 42:
                throw errors_1.UnknownChipFamilyError;

              case 43:
                res = macAddr[0].toString(16).toUpperCase().padStart(2, "0");

                for (i = 1; i < 6; i++) {
                  res += ":" + macAddr[i].toString(16).toUpperCase().padStart(2, "0");
                }

                return _context6.abrupt("return", res);

              case 46:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function macAddr() {
        return _macAddr.apply(this, arguments);
      }

      return macAddr;
    }()
    /**
     * Read the OTP data for this chip.
     */

  }, {
    key: "readEfuses",
    value: function () {
      var _readEfuses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var chipFamily, baseAddr, efuses, i;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.chipFamily();

              case 2:
                chipFamily = _context7.sent;

                if (!(chipFamily == ChipFamily.ESP8266)) {
                  _context7.next = 7;
                  break;
                }

                baseAddr = 0x3ff00050;
                _context7.next = 12;
                break;

              case 7:
                if (!(chipFamily === ChipFamily.ESP32 || chipFamily === ChipFamily.ESP32S2)) {
                  _context7.next = 11;
                  break;
                }

                baseAddr = 0x6001a000;
                _context7.next = 12;
                break;

              case 11:
                throw errors_1.UnknownChipFamilyError;

              case 12:
                efuses = new Uint32Array(4);
                i = 0;

              case 14:
                if (!(i < 4)) {
                  _context7.next = 21;
                  break;
                }

                _context7.next = 17;
                return this.readRegister(baseAddr + 4 * i);

              case 17:
                efuses[i] = _context7.sent;

              case 18:
                i++;
                _context7.next = 14;
                break;

              case 21:
                return _context7.abrupt("return", efuses);

              case 22:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function readEfuses() {
        return _readEfuses.apply(this, arguments);
      }

      return readEfuses;
    }()
  }, {
    key: "efuses",
    value: function () {
      var _efuses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this._efuses === undefined)) {
                  _context8.next = 4;
                  break;
                }

                _context8.next = 3;
                return this.readEfuses();

              case 3:
                this._efuses = _context8.sent;

              case 4:
                return _context8.abrupt("return", this._efuses);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function efuses() {
        return _efuses.apply(this, arguments);
      }

      return efuses;
    }()
    /**
     * Read a register within the ESP chip RAM.
     */

  }, {
    key: "readRegister",
    value: function () {
      var _readRegister = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(reg) {
        var packet, register;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.options.debug) {
                  this.logger.debug("Reading Register", reg);
                }

                packet = pack("I", reg);
                _context9.next = 4;
                return this.checkCommand(ESP_READ_REG, packet);

              case 4:
                register = _context9.sent;
                return _context9.abrupt("return", unpack("I", register)[0]);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function readRegister(_x2) {
        return _readRegister.apply(this, arguments);
      }

      return readRegister;
    }()
    /**
     * ESP32, ESP32S2 or ESP8266 based on which chip type we're talking to.
     */

  }, {
    key: "chipFamily",
    value: function () {
      var _chipFamily = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var datareg;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(this._chipfamily === undefined)) {
                  _context10.next = 17;
                  break;
                }

                _context10.next = 3;
                return this.readRegister(CHIP_DETECT_MAGIC_REG_ADDR);

              case 3:
                datareg = _context10.sent;

                if (!(datareg == ESP32_DETECT_MAGIC_VALUE)) {
                  _context10.next = 8;
                  break;
                }

                this._chipfamily = ChipFamily.ESP32;
                _context10.next = 17;
                break;

              case 8:
                if (!(datareg == ESP8266_DETECT_MAGIC_VALUE)) {
                  _context10.next = 12;
                  break;
                }

                this._chipfamily = ChipFamily.ESP8266;
                _context10.next = 17;
                break;

              case 12:
                if (!(datareg == ESP32S2_DETECT_MAGIC_VALUE)) {
                  _context10.next = 16;
                  break;
                }

                this._chipfamily = ChipFamily.ESP32S2;
                _context10.next = 17;
                break;

              case 16:
                throw errors_1.UnknownChipFamilyError;

              case 17:
                return _context10.abrupt("return", this._chipfamily);

              case 18:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function chipFamily() {
        return _chipFamily.apply(this, arguments);
      }

      return chipFamily;
    }()
    /**
     * The specific name of the chip.
     */

  }, {
    key: "chipName",
    value: function () {
      var _chipName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var efuses, chipFamily;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.efuses();

              case 2:
                efuses = _context11.sent;
                _context11.next = 5;
                return this.chipFamily();

              case 5:
                chipFamily = _context11.sent;

                if (!(chipFamily == ChipFamily.ESP32)) {
                  _context11.next = 8;
                  break;
                }

                return _context11.abrupt("return", "ESP32");

              case 8:
                if (!(chipFamily == ChipFamily.ESP32S2)) {
                  _context11.next = 10;
                  break;
                }

                return _context11.abrupt("return", "ESP32-S2");

              case 10:
                if (!(chipFamily == ChipFamily.ESP8266)) {
                  _context11.next = 14;
                  break;
                }

                if (!(efuses[0] & 1 << 4 || efuses[2] & 1 << 16)) {
                  _context11.next = 13;
                  break;
                }

                return _context11.abrupt("return", "ESP8285");

              case 13:
                return _context11.abrupt("return", "ESP8266EX");

              case 14:
                throw errors_1.UnknownChipFamilyError;

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function chipName() {
        return _chipName.apply(this, arguments);
      }

      return chipName;
    }()
    /**
     * Send a command packet, check that the command succeeded.
     */

  }, {
    key: "checkCommand",
    value: function () {
      var _checkCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(opcode, buffer) {
        var checksum,
            timeout,
            unlisten,
            resp,
            data,
            value,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                checksum = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : 0;
                timeout = _args12.length > 3 && _args12[3] !== undefined ? _args12[3] : DEFAULT_TIMEOUT;
                timeout = Math.min(timeout, MAX_TIMEOUT);
                unlisten = this.reader.listen();
                _context12.prev = 4;
                _context12.next = 7;
                return this.sendCommand(opcode, buffer, checksum);

              case 7:
                _context12.next = 9;
                return this.getResponse(opcode, timeout);

              case 9:
                resp = _context12.sent;
                data = resp.data;
                value = resp.value;

                if (!(data.length > 4)) {
                  _context12.next = 16;
                  break;
                }

                return _context12.abrupt("return", data);

              case 16:
                return _context12.abrupt("return", value);

              case 17:
                _context12.prev = 17;
                unlisten();
                return _context12.finish(17);

              case 20:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[4,, 17, 20]]);
      }));

      function checkCommand(_x3, _x4) {
        return _checkCommand.apply(this, arguments);
      }

      return checkCommand;
    }()
  }, {
    key: "sendCommand",
    value: function () {
      var _sendCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(opcode, buffer) {
        var checksum,
            packet,
            res,
            _args13 = arguments;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                checksum = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : 0;
                packet = this._sendCommandBuffer;
                packet.reset();
                packet.push(0xc0, 0x00); // direction

                packet.push(opcode);
                packet.pack("H", buffer.length);
                packet.slipEncode = true;
                packet.pack("I", checksum);
                packet.copy(buffer);
                packet.slipEncode = false;
                packet.push(0xc0);
                res = packet.view();

                if (this.options.debug) {
                  this.logger.debug("Writing", res.length, "byte" + (res.length == 1 ? "" : "s") + ":", res);
                }

                _context13.next = 15;
                return this.writeToStream(res);

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function sendCommand(_x5, _x6) {
        return _sendCommand.apply(this, arguments);
      }

      return sendCommand;
    }()
  }, {
    key: "getResponse",
    value: function () {
      var _getResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(opcode) {
        var timeout,
            reply,
            opcode_ret,
            res,
            value,
            data,
            _args14 = arguments;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                timeout = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : DEFAULT_TIMEOUT;
                _context14.prev = 1;
                _context14.next = 4;
                return this.reader.packet(12, timeout);

              case 4:
                reply = _context14.sent;

                if (this.options.debug) {
                  this.logger.debug("Reading", reply.length, "byte" + (reply.length == 1 ? "" : "s") + ":", reply);
                }

                opcode_ret = reply[1];

                if (!(opcode !== opcode_ret)) {
                  _context14.next = 10;
                  break;
                }

                this.logger.debug("invalid opcode response. expected", opcode, "got", opcode_ret);
                throw "invalid opcode response";

              case 10:
                res = Array.from(reply);
                value = res.slice(4, 8);
                data = res.slice(8, -1);

                if (this.options.debug) {
                  this.logger.debug("value:", value, "data:", data);
                }

                return _context14.abrupt("return", {
                  value: value,
                  data: data
                });

              case 17:
                _context14.prev = 17;
                _context14.t0 = _context14["catch"](1);
                throw _context14.t0;

              case 20:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[1, 17]]);
      }));

      function getResponse(_x7) {
        return _getResponse.apply(this, arguments);
      }

      return getResponse;
    }()
  }, {
    key: "setBaudRate",

    /**
     * Change the baud rate for the serial port.
     */
    value: function () {
      var _setBaudRate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(prevBaud, baud) {
        var buffer, wasSilent;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.logger.log("Attempting to change baud rate from", prevBaud, "to", baud, "..."); // Signal ESP32 stub that we will change the baud rate

                buffer = pack("<II", baud, this.isStub ? prevBaud : 0);
                _context15.next = 4;
                return this.checkCommand(ESP_CHANGE_BAUDRATE, buffer);

              case 4:
                _context15.next = 6;
                return this.disconnect();

              case 6:
                _context15.next = 8;
                return this.serialPort.close();

              case 8:
                _context15.next = 10;
                return this.serialPort.open({
                  baudRate: baud
                });

              case 10:
                this.reader.start();
                _context15.next = 13;
                return (0, util_1.sleep)(50);

              case 13:
                _context15.next = 15;
                return this.reader.waitSilent(10, 200);

              case 15:
                wasSilent = _context15.sent;

                if (!wasSilent) {
                  this.logger.debug("after baud change reader was not silent");
                } // Baud rate was changed


                this.logger.log("Changed baud rate to", baud);
                this.baudRate = baud;

              case 19:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setBaudRate(_x8, _x9) {
        return _setBaudRate.apply(this, arguments);
      }

      return setBaudRate;
    }()
    /**
     * Put into ROM bootload mode & attempt to synchronize with the
     * ESP ROM bootloader, we will retry a few times
     */

  }, {
    key: "sync",
    value: function () {
      var _sync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var unlisten, _yield$this$getRespon, data;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                unlisten = this.reader.listen();
                _context16.prev = 1;
                _context16.next = 4;
                return this.sendCommand(ESP_SYNC, SYNC_PACKET);

              case 4:
                _context16.next = 6;
                return this.getResponse(ESP_SYNC, SYNC_TIMEOUT);

              case 6:
                _yield$this$getRespon = _context16.sent;
                data = _yield$this$getRespon.data;

                if (!(data.length > 1 && data[0] == 0 && data[1] == 0)) {
                  _context16.next = 10;
                  break;
                }

                return _context16.abrupt("return", true);

              case 10:
                return _context16.abrupt("return", false);

              case 11:
                _context16.prev = 11;
                unlisten();
                return _context16.finish(11);

              case 14:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[1,, 11, 14]]);
      }));

      function sync() {
        return _sync.apply(this, arguments);
      }

      return sync;
    }()
  }, {
    key: "getFlashWriteSize",
    value: function getFlashWriteSize() {
      if (this.isStub) {
        return STUB_FLASH_WRITE_SIZE;
      }

      return FLASH_WRITE_SIZE;
    }
    /**
     * Write data to the flash.
     */

  }, {
    key: "flashData",
    value: function () {
      var _flashData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(binaryData) {
        var offset,
            progressCallback,
            encrypted,
            filesize,
            blocks,
            seq,
            address,
            position,
            stamp,
            flashWriteSize,
            block,
            _args17 = arguments;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                offset = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : 0;
                progressCallback = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : undefined;
                encrypted = _args17.length > 3 && _args17[3] !== undefined ? _args17[3] : false;
                binaryData = padTo(binaryData, encrypted ? 32 : 4);
                filesize = binaryData.byteLength;
                this.logger.log("Writing data with filesize:", filesize);
                _context17.next = 8;
                return this.flashBegin(filesize, offset);

              case 8:
                blocks = _context17.sent;
                seq = 0;
                address = offset;
                position = 0;
                stamp = Date.now();
                flashWriteSize = this.getFlashWriteSize();

              case 14:
                if (!(filesize - position > 0)) {
                  _context17.next = 24;
                  break;
                }

                if (this.options.debug) {
                  this.logger.debug("Writing at " + (0, util_1.toHex)(address + seq * flashWriteSize, 8) + "... (", (seq + 1) / blocks, "%)");
                }

                if (progressCallback) {
                  progressCallback(seq, blocks);
                }

                if (filesize - position >= flashWriteSize) {
                  block = binaryData.subarray(position, position + flashWriteSize);
                } else {
                  // Pad the last block
                  block = binaryData.subarray(position, filesize);
                }

                _context17.next = 20;
                return this.flashBlock(block, flashWriteSize, seq, 2000);

              case 20:
                seq += 1;
                position += flashWriteSize;
                _context17.next = 14;
                break;

              case 24:
                if (!this.isStub) {
                  _context17.next = 27;
                  break;
                }

                _context17.next = 27;
                return this.readRegister(CHIP_DETECT_MAGIC_REG_ADDR);

              case 27:
                if (this.options.debug) {
                  this.logger.debug("Took", Date.now() - stamp, "ms to write", filesize, "bytes");
                }

              case 28:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function flashData(_x10) {
        return _flashData.apply(this, arguments);
      }

      return flashData;
    }()
  }, {
    key: "flashBlock",
    value: function () {
      var _flashBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(data, flashWriteSize, seq) {
        var timeout,
            buffer,
            _args18 = arguments;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                timeout = _args18.length > 3 && _args18[3] !== undefined ? _args18[3] : 100;
                buffer = this._flashBlockBuffer;
                buffer.reset();
                buffer.pack("<IIII", flashWriteSize, seq, 0, 0);
                buffer.copy(data);

                if (data.length < flashWriteSize) {
                  buffer.fill(0xff, flashWriteSize - data.length);
                }

                _context18.next = 8;
                return this.checkCommand(ESP_FLASH_DATA, buffer.view(), EspLoader.checksum(data), timeout);

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function flashBlock(_x11, _x12, _x13) {
        return _flashBlock.apply(this, arguments);
      }

      return flashBlock;
    }()
  }, {
    key: "flashBegin",
    value: function () {
      var _flashBegin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var size,
            offset,
            encrypted,
            eraseSize,
            buffer,
            chipFamily,
            flashWriteSize,
            numBlocks,
            timeout,
            stamp,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                size = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : 0;
                offset = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : 0;
                encrypted = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : false;
                buffer = new util_1.Uint8Buffer(32);

                if (!this.isStub) {
                  _context19.next = 8;
                  break;
                }

                _context19.t0 = null;
                _context19.next = 11;
                break;

              case 8:
                _context19.next = 10;
                return this.chipFamily();

              case 10:
                _context19.t0 = _context19.sent;

              case 11:
                chipFamily = _context19.t0;
                flashWriteSize = this.getFlashWriteSize();

                if (!(chipFamily === ChipFamily.ESP32 || chipFamily === ChipFamily.ESP32S2)) {
                  _context19.next = 16;
                  break;
                }

                _context19.next = 16;
                return this.checkCommand(ESP_SPI_ATTACH, new Uint8Array(8).fill(0));

              case 16:
                if (!(chipFamily == ChipFamily.ESP32)) {
                  _context19.next = 20;
                  break;
                }

                // We are hardcoded for 4MB flash on ESP32
                buffer.pack("<IIIIII", 0, this.options.flashSize, 0x10000, 4096, 256, 0xffff);
                _context19.next = 20;
                return this.checkCommand(ESP_SPI_SET_PARAMS, buffer.view());

              case 20:
                numBlocks = Math.floor((size + flashWriteSize - 1) / flashWriteSize);

                if (chipFamily == ChipFamily.ESP8266) {
                  eraseSize = EspLoader.getEraseSize(offset, size);
                } else {
                  eraseSize = size;
                }

                if (this.isStub) {
                  timeout = DEFAULT_TIMEOUT;
                } else {
                  timeout = timeoutPerMb(ERASE_REGION_TIMEOUT_PER_MB, size);
                }

                stamp = Date.now();
                buffer.reset();
                buffer.pack("<IIII", eraseSize, numBlocks, flashWriteSize, offset);

                if (chipFamily == ChipFamily.ESP32S2) {
                  buffer.pack("<I", encrypted ? 1 : 0);
                }

                this.logger.log("Write size", eraseSize, " blocks ", numBlocks, " block size ", flashWriteSize, " offset " + (0, util_1.toHex)(offset, 4) // + ", encrypted " + (encrypted ? "yes" : "no")
                );
                _context19.next = 30;
                return this.checkCommand(ESP_FLASH_BEGIN, buffer.view(), 0, timeout);

              case 30:
                if (size != 0 && !this.isStub) {
                  this.logger.log("Took", Date.now() - stamp, "ms to erase", numBlocks, "bytes");
                }

                return _context19.abrupt("return", numBlocks);

              case 32:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function flashBegin() {
        return _flashBegin.apply(this, arguments);
      }

      return flashBegin;
    }()
    /**
     * Leave flash mode and run/reboot
     *
     * @param reboot wheather or not to reboot
     */

  }, {
    key: "flashFinish",
    value: function () {
      var _flashFinish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var reboot,
            buffer,
            _args20 = arguments;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                reboot = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : false;
                _context20.next = 3;
                return this.flashBegin(0, 0);

              case 3:
                buffer = pack("<I", reboot ? 0 : 1);
                _context20.next = 6;
                return this.checkCommand(ESP_FLASH_END, buffer);

              case 6:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function flashFinish() {
        return _flashFinish.apply(this, arguments);
      }

      return flashFinish;
    }()
    /**
     * Calculate an erase size given a specific size in bytes.
     * Provides a workaround for the bootloader erase bug.
     */

  }, {
    key: "memBegin",
    value: function () {
      var _memBegin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(size, blocks, blockSize, offset) {
        var chipFamily, stub, load_start, load_end, _i, _arr, _arr$_i, start, end;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!this.isStub) {
                  _context21.next = 17;
                  break;
                }

                _context21.next = 3;
                return this.chipFamily();

              case 3:
                chipFamily = _context21.sent;
                stub = getStub(chipFamily);
                load_start = offset;
                load_end = offset + size;
                this.logger.log(load_start, load_end);
                this.logger.log(stub.dataStart, stub.data.length, stub.textStart, stub.text.length);
                _i = 0, _arr = [[stub.dataStart, stub.dataStart + stub.data.length], [stub.textStart, stub.textStart + stub.text.length]];

              case 10:
                if (!(_i < _arr.length)) {
                  _context21.next = 17;
                  break;
                }

                _arr$_i = _slicedToArray(_arr[_i], 2), start = _arr$_i[0], end = _arr$_i[1];

                if (!(load_start < end && load_end > start)) {
                  _context21.next = 14;
                  break;
                }

                throw "Software loader is resident at " + (0, util_1.toHex)(start, 8) + "-" + (0, util_1.toHex)(end, 8) + ". " + "Can't load binary at overlapping address range " + (0, util_1.toHex)(load_start, 8) + "-" + (0, util_1.toHex)(load_end, 8) + ". " + "Try changing the binary loading address.";

              case 14:
                _i++;
                _context21.next = 10;
                break;

              case 17:
                return _context21.abrupt("return", this.checkCommand(ESP_MEM_BEGIN, pack("<IIII", size, blocks, blockSize, offset)));

              case 18:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function memBegin(_x14, _x15, _x16, _x17) {
        return _memBegin.apply(this, arguments);
      }

      return memBegin;
    }()
  }, {
    key: "memBlock",
    value: function () {
      var _memBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(data, seq) {
        var buffer;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                buffer = this._memBlockBuffer;
                buffer.reset();
                buffer.pack("<IIII", data.length, seq, 0, 0);
                buffer.copy(data);
                _context22.next = 6;
                return this.checkCommand(ESP_MEM_DATA, buffer.view(), EspLoader.checksum(data));

              case 6:
                return _context22.abrupt("return", _context22.sent);

              case 7:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function memBlock(_x18, _x19) {
        return _memBlock.apply(this, arguments);
      }

      return memBlock;
    }()
  }, {
    key: "memFinish",
    value: function () {
      var _memFinish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var entrypoint,
            data,
            _args23 = arguments;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                entrypoint = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : 0;
                data = pack("<II", entrypoint === 0 ? 1 : 0, entrypoint);
                _context23.next = 4;
                return this.checkCommand(ESP_MEM_END, data, 0, MEM_END_ROM_TIMEOUT);

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function memFinish() {
        return _memFinish.apply(this, arguments);
      }

      return memFinish;
    }()
    /**
     * loads the stub onto the device.
     *
     * @param stub Stub to load
     */

  }, {
    key: "loadStub",
    value: function () {
      var _loadStub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(stub) {
        var _this = this;

        var ramBlock, writeMem, chipFamily, unlisten, p, str;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                ramBlock = ESP_RAM_BLOCK;

                writeMem = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(data, offset) {
                    var length, blocks, seq, fromOffs, toOffs;
                    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            length = data.length;
                            blocks = Math.floor((length + ramBlock - 1) / ramBlock);
                            _context24.next = 4;
                            return _this.memBegin(length, blocks, ramBlock, offset);

                          case 4:
                            seq = 0;

                          case 5:
                            if (!(seq < blocks)) {
                              _context24.next = 14;
                              break;
                            }

                            fromOffs = seq * ramBlock;
                            toOffs = fromOffs + ramBlock;

                            if (toOffs > length) {
                              toOffs = length;
                            }

                            _context24.next = 11;
                            return _this.memBlock(data.slice(fromOffs, toOffs), seq);

                          case 11:
                            seq++;
                            _context24.next = 5;
                            break;

                          case 14:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24);
                  }));

                  return function writeMem(_x21, _x22) {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context25.next = 4;
                return this.chipFamily();

              case 4:
                chipFamily = _context25.sent;

                if (stub === undefined) {
                  stub = getStub(chipFamily);
                }

                this.logger.log("Uploading stub...");
                _context25.next = 9;
                return writeMem(stub.text, stub.textStart);

              case 9:
                _context25.next = 11;
                return writeMem(stub.data, stub.dataStart);

              case 11:
                this.logger.log("Running stub...");
                unlisten = this.reader.listen();
                _context25.prev = 13;
                _context25.next = 16;
                return this.memFinish(stub.entry);

              case 16:
                _context25.next = 18;
                return this.reader.packet(6, 1000);

              case 18:
                p = _context25.sent;
                str = String.fromCharCode.apply(String, _toConsumableArray(p));

                if (!(str !== "OHAI")) {
                  _context25.next = 22;
                  break;
                }

                throw "Failed to start stub. Unexpected response: " + str;

              case 22:
                _context25.prev = 22;
                unlisten();
                return _context25.finish(22);

              case 25:
                this.logger.log("Stub is now running...");
                this.isStub = true;
                this._chipfamily = undefined;
                this._efuses = undefined;

              case 29:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[13,, 22, 25]]);
      }));

      function loadStub(_x20) {
        return _loadStub.apply(this, arguments);
      }

      return loadStub;
    }()
    /**
     * erase the flash of the device
     *
     * @param timeoutMs the timeout of erasing
     */

  }, {
    key: "eraseFlash",
    value: function () {
      var _eraseFlash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var timeoutMs,
            _args26 = arguments;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                timeoutMs = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : CHIP_ERASE_TIMEOUT;

                if (this.isStub) {
                  _context26.next = 3;
                  break;
                }

                throw "Only supported on stub";

              case 3:
                _context26.next = 5;
                return this.checkCommand(ESP_ERASE_FLASH, emptyByteArray, 0, timeoutMs);

              case 5:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function eraseFlash() {
        return _eraseFlash.apply(this, arguments);
      }

      return eraseFlash;
    }()
  }, {
    key: "logger",
    get: function get() {
      return this.options.logger;
    }
  }], [{
    key: "checksum",
    value: function checksum(data) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ESP_CHECKSUM_MAGIC;

      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var b = _step.value;
          state ^= b;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return state;
    }
  }, {
    key: "getEraseSize",
    value: function getEraseSize(offset, size) {
      var sectorsPerBlock = 16;
      var sectorSize = FLASH_SECTOR_SIZE;
      var numSectors = Math.floor((size + sectorSize - 1) / sectorSize);
      var startSector = Math.floor(offset / sectorSize);
      var headSectors = sectorsPerBlock - startSector % sectorsPerBlock;

      if (numSectors < headSectors) {
        headSectors = numSectors;
      }

      if (numSectors < 2 * headSectors) {
        return Math.floor((numSectors + 1) / 2 * sectorSize);
      }

      return (numSectors - headSectors) * sectorSize;
    }
  }]);

  return EspLoader;
}();

exports.EspLoader = EspLoader;

function getStub(chipFamily) {
  switch (chipFamily) {
    case ChipFamily.ESP32:
      return stubs_1.ESP32;

    default:
      throw "Unsupported chipFamily: " + chipFamily;
  }
}

function padTo(image, alignment) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0xff;
  var pad = image.byteLength % alignment;

  if (pad == 0) {
    return image;
  }

  var res = new Uint8Array(image.byteLength + (alignment - pad));
  res.set(image);
  res.fill(padding, image.byteLength);
  return res;
}
/**
 * Scales timeouts which are size-specific
 */


function timeoutPerMb(secondsPerMb, sizeBytes) {
  var result = Math.floor(secondsPerMb * (sizeBytes / 0x1e6));

  if (result < DEFAULT_TIMEOUT) {
    return DEFAULT_TIMEOUT;
  }

  return result;
}

function pack(format) {
  var pointer = 0;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var data = args;

  if (format.replace(/[<>]/, "").length != data.length) {
    throw "Pack format to Argument count mismatch";
  }

  var bytes = [];
  var littleEndian = true;

  for (var i = 0; i < format.length; i++) {
    if (format[i] == "<") {
      littleEndian = true;
    } else if (format[i] == ">") {
      littleEndian = false;
    } else if (format[i] == "B") {
      pushBytes(data[pointer], 1);
      pointer++;
    } else if (format[i] == "H") {
      pushBytes(data[pointer], 2);
      pointer++;
    } else if (format[i] == "I") {
      pushBytes(data[pointer], 4);
      pointer++;
    } else {
      throw "Unhandled character in pack format";
    }
  }

  function pushBytes(value, byteCount) {
    for (var _i2 = 0; _i2 < byteCount; _i2++) {
      if (littleEndian) {
        bytes.push(value >> _i2 * 8 & 0xff);
      } else {
        bytes.push(value >> (byteCount - _i2) * 8 & 0xff);
      }
    }
  }

  return Uint8Array.from(bytes);
}

function unpack(format, bytes) {
  var pointer = 0;
  var data = [];

  var _iterator2 = _createForOfIteratorHelper(format),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var c = _step2.value;

      if (c == "B") {
        data.push(bytes[pointer] & 0xff);
        pointer += 1;
      } else if (c == "H") {
        data.push(bytes[pointer] & 0xff | (bytes[pointer + 1] & 0xff) << 8);
        pointer += 2;
      } else if (c == "I") {
        data.push(bytes[pointer] & 0xff | (bytes[pointer + 1] & 0xff) << 8 | (bytes[pointer + 2] & 0xff) << 16 | (bytes[pointer + 3] & 0xff) << 24);
        pointer += 4;
      } else {
        throw "Unhandled character in unpack format";
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return data;
}

var emptyByteArray = new Uint8Array();